export const isMac = /Mac/.test(navigator.userAgent);
